import React from 'react';

import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { OKR_TYPES } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Overview/ParentOKR';
import { TimelineSelect } from 'components/TimelineSelect/TimelineSelect';
import { useViewPageName } from 'components/Views/Hooks/useViewPageName';
import { useDispatch } from 'react-redux';

import InputLabel from 'uiToolkitV1/InputLabel';

export const OKRCreationTimeline = ({
  okrUuid,
  okrType,
  okrVisibilityType,
  okrText,
  objectiveLevel,
  timeBoundDetails,
  parentPost,
  okrHasNoChildren,
  isReadOnly,
  showLabel = true,
}) => {
  const dispatch = useDispatch();
  const page = useViewPageName();

  const { uuid, text = '', type = OKR_TYPES.OBJECTIVE, visibilityType = 'PRIVATE' } = parentPost ?? {};

  const handleTimelineChange = (selectedTimePeriod) => {
    // const payload = {
    //   parentUuid: uuid,
    //   parentText: text,
    //   parentType: type,
    //   parentVisibilityType: visibilityType,
    //   okrTimePeriod: selectedTimePeriod,
    //   okrVisibilityType,
    //   okrText,
    //   okrUuid,
    //   okrType,
    //   objectiveLevel,
    //   okrHasNoChildren,
    //   eventType: 'Timeline',
    //   source: okrType === OKR_TYPES.OBJECTIVE ? 'Add Obj Panel' : 'Add KR Panel',
    // };

    dispatch(
      updateOKR({
        timeBoundDetails: selectedTimePeriod,
        parentPost: {
          uuid: null,
          text: 'None',
          type: OKR_TYPES.OBJECTIVE,
          visibilityType: 'PRIVATE',
        },
        startTS: selectedTimePeriod?.startTS,
        dueTS: selectedTimePeriod?.endTS,
      })
    );

    // sendClickedRealignedEvent({
    //   eventProperties: {
    //     source: okrType === OKR_TYPES.OBJECTIVE ? 'Add Obj Panel' : 'Add KR Panel',
    //     page,
    //     type: 'Timeline',
    //     goalId: okrUuid,
    //   },
    // });

    // dispatch(openSelectParentOKRPanel(payload));
  };

  if (!showLabel) {
    return (
      <TimelineSelect
        showCalendarIcon
        selectedTimeline={timeBoundDetails}
        onSelect={handleTimelineChange}
        isReadOnly={isReadOnly}
      />
    );
  }

  return (
    <InputLabel
      labelText="Timeline"
      containerProps={{
        sx: {
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        },
      }}
    >
      <TimelineSelect selectedTimeline={timeBoundDetails} onSelect={handleTimelineChange} isReadOnly={isReadOnly} />
    </InputLabel>
  );
};
